// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"351":"commons","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"351":"0ed382055b1177c7768d","678":"07c237daa7b0317efd2a","731":"e1167f9acc9347d3ba8a","843":"a75101acca522f1da784","883":"1b3e12fe170937a740dc"}[chunkId] + ".js";
};